import axios from "axios";
import { Environment } from "./../../services/env";

export const apiClient = axios.create({ baseURL: Environment.apiUrl, withCredentials: true });
